import {
  BottomSheetContainer,
  Colors,
  createUseBottomSheetModal,
  Flex,
  IconCheck,
  Typography,
  VerticalSpacing,
} from '@banhala/ui-kit';
import type { SortType } from '../constants';

interface SortBottomSheetParam {
  options: SortType[];
  selectedKey: string;
}

export const useSortBottomSheet = createUseBottomSheetModal<
  { selected: SortType },
  SortBottomSheetParam
>(({ confirm, param }) => {
  return (
    <BottomSheetContainer>
      <VerticalSpacing size={16} />
      {param.options.map(option => {
        const isSelected = option.key === param.selectedKey;
        return (
          <Flex
            horizontal
            key={option.key}
            alignItems={'center'}
            justifyContent={'space-between'}
            padding={{ horizontal: 16, vertical: 16 }}
            onPress={() => confirm({ selected: option })}
          >
            <Typography
              type={isSelected ? 'subtitle1' : 'body1'}
              color={isSelected ? 'content_pink_primary' : undefined}
            >
              {option.name}
            </Typography>
            {isSelected && (
              <IconCheck size={20} fill={Colors.content_pink_primary} />
            )}
          </Flex>
        );
      })}
    </BottomSheetContainer>
  );
});
